import { render } from "./IconBadge.vue?vue&type=template&id=4b06783c"
import script from "./IconBadge.vue?vue&type=script&lang=js"
export * from "./IconBadge.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/app/app/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__